import { memo, useState, useEffect } from 'react';
import styles from './publicationDetail.module.scss';
import { PublicationDetailProps } from '../../interfaces/components';
import { Markup } from 'interweave';
import { addPointsInText, boldBetweenAsterisks } from '../../helpers/app';
import Slider from '../SliderTwo';
import NewCard from '../NewCard';
import Favorite from '../../containers/Favorite/FavoriteContainer';
import ShareButton from '../ShareButton';
import InformationLoader from './Loader/Information/InformationLoader';
import VehicleSimilarsLoader from './Loader/VehicleSimilars/VehicleSimilarsLoader';
import { images } from '../../constants/images';
import { Divider, Skeleton } from '@mui/material';
import DescriptionLoader from './Loader/Description/DescriptionLoader';
import DetailLoader from './Loader/Detail/DetailLoader';
import Button from '../../components/Button';
import { Chip } from '@mui/material';
import { usePublicationDetail } from './hooks/usePublicationDetail';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PublicationDetailMobile from '../PublicationDetailMobile/PublicationDetailMobile';
import { useLocation } from 'react-router-dom';

const PublicationDetail = ({
    type = "publication",
    publication,
    loading = false,
    clickFavorite = () => { },
    publications,
    children,
    buttonOff = false,
    handleDealerLogoClick,
    logoDealerships,
    onLinzeCheckClick,
    vehicleTypeSelected,
    setVehicleTypeReducer
}: PublicationDetailProps) => {
    const location = useLocation();
    const hookData = usePublicationDetail({ publication });

    const {
        isBonus,
        formData,
        selectedFeatures,
        getIndicatorPositionFromSuggested,
        getPriceDifferenceMessage,
        getIndicatorPosition,
        getPriceCategory,
        getPriceCategoryPublication,
        getIndicatorPositionPublication,
        hasValidSuggestedPrices,
        hasValidSuggestedPricesPublication
    } = publication && !loading ? hookData : {
        isBonus: false,
        formData: null,
        selectedFeatures: [],
        getIndicatorPositionFromSuggested: () => 0,
        getPriceDifferenceMessage: () => "",
        getIndicatorPosition: () => 0,
        getIndicatorPositionPublication: () => 0,
        getPriceCategory: () => "",
        getPriceCategoryPublication: () => "",
        hasValidSuggestedPrices: false,
        hasValidSuggestedPricesPublication: false
    };

    const [sliderLimit, setSliderLimit] = useState(3);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 700) {
                setSliderLimit(1);
            } else if (width < 1024) {
                setSliderLimit(3);
            } else {
                setSliderLimit(3);
            }
        };

        handleResize(); // Ejecutar al montar
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if(location.pathname.includes('nuevos') || location.pathname.includes('usados')){
            const vehicleType = location.pathname.includes('nuevos') ? 'new' : 'used';
            setVehicleTypeReducer(vehicleType);
        }
    }, [])

    return (
        <>
            <PublicationDetailMobile
                type={type}
                publication={publication}
                loading={loading}
                children={children}
                logoDealerships={logoDealerships}
                handleDealerLogoClick={handleDealerLogoClick}
                onLinzeCheckClick={onLinzeCheckClick}
            />
            <div className={styles.mainContent}>
                <div className={styles.leftColumn}>
                    <div className={styles.leftBox}>
                        <div className={styles.sliderContainer}>
                            {type !== "myPublication" && (
                                <div className={styles.icarOverlay} onClick={onLinzeCheckClick}>
                                    <span>
                                        <img src={images.icarIcon} alt="iCar" className={styles.icarIcon} />
                                        <Button
                                            title="Adquirir informe técnico"
                                            onPress={onLinzeCheckClick}
                                            tertiary
                                            size='small'
                                            className={`${styles.btnInformeOverlay} ${styles.customButton}`}
                                        />
                                    </span>
                                </div>
                            )}

                            <Slider
                                className={styles.slider}
                                type="thumbs"
                                options={
                                    publication?.pictures && publication?.pictures.length > 0
                                        ?
                                        publication?.pictures.map((item: any, index: number) => (
                                            <img loading="lazy" key={index} src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url} className={publication?.paused && styles.paused} alt={`${publication?.title} ${publication.version ?? ""} año ${publication.year}`} />
                                        ))
                                        :
                                        [1].map((_: any, index: number) => (
                                            <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" />
                                        ))
                                }
                                pagination
                                loading={loading && (!Array.isArray(publication?.pictures) && !publication?.pictures?.length)}
                            />
                        </div>
                        <div className={styles.table}>
                            <p className={styles.region}>{publication?.region}</p>
                            <div className={styles.comparaContainer}>

                                <p className={styles.title}>Características</p>

                            </div>
                            <table>
                                <body>
                                    {
                                        window.innerWidth <= 1024 && publication?.caracteristics ? publication?.caracteristics.map((item: any, index: number) => (
                                            <tr key={index} className={styles.item}>
                                                <td className={styles.icon}>
                                                    <img src={`${item?.icon}`} alt={item?.name} />
                                                </td>
                                                <th className={styles.name}>{item?.name}</th>
                                                <td className={styles.value}>
                                                    {
                                                        loading
                                                            ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                            : item?.value ?? "-"
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                            :
                                            publication?.caracteristics && publication?.caracteristics.map((item: any, index: number) => {
                                                if (index > 3) return null;
                                                return (
                                                    <tr key={index} className={styles.item}>
                                                        <td className={styles.icon}>
                                                            <img src={`${item?.icon}`} alt={item?.name} />
                                                        </td>
                                                        <th className={styles.name}>{item?.name}</th>
                                                        <td className={styles.value}>
                                                            {
                                                                loading
                                                                    ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                                    : item?.value ?? "-"
                                                            }
                                                        </td>
                                                        <td className={styles.icon}>
                                                            <img src={`${publication?.caracteristics[index + 4]?.icon}`} alt={publication?.caracteristics[index + 4]?.name} />
                                                        </td>
                                                        <th className={styles.name}>{publication?.caracteristics[index + 4]?.name}</th>
                                                        <td className={styles.value}>
                                                            {
                                                                loading
                                                                    ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                                    : publication?.caracteristics[index + 4]?.value ?? "-"
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                    }
                                </body>
                            </table>
                        </div>
                        {type !== "salePost" && (
                            loading ? (
                                <div className={styles.description}>
                                    <DescriptionLoader />
                                </div>
                            ) : (
                                <div className={styles.salePostContainer}>
                                    {/* DESCRIPCIÓN VEHÍCULO */}
                                    {publication?.chatgpt_description && (
                                        <div className={styles.vehicleDescription}>
                                            <div className={styles.descriptionHeader}>
                                                <p className={styles.title}>Descripción del vehículo</p>
                                                <p className={styles.subtitle}>
                                                    <AutoAwesomeIcon className={styles.svg} />
                                                    <span className={styles.textIA}>Generado por Linze IA</span>
                                                </p>
                                            </div>
                                            <p className={styles.descriptionText}>
                                                {publication.chatgpt_description}
                                            </p>
                                        </div>
                                    )}

                                    {/* CARACTERÍSTICAS ADICIONALES (SIEMPRE SE MUESTRA) */}
                                    <div className={styles.additionalFeatures}>
                                        <p className={styles.title}>Características adicionales</p>
                                        {!publication?.additional_characters || publication.additional_characters.length === 0 ? (
                                            <p className={styles.descriptionText}>No añadiste características adicionales aún</p>
                                        ) : (
                                            <div className={styles.featuresList}>
                                                {publication.additional_characters.map((category: any) =>
                                                    category.value
                                                        .filter((item: any) => item.value === true)
                                                        .map((item: any) => (
                                                            <Chip
                                                                key={item.code}
                                                                label={item.name}
                                                                className={styles.featureChip}
                                                                sx={{
                                                                    margin: '0 4px 4px 0',
                                                                    height: '28px',
                                                                    color: 'rgba(115, 115, 115, 1)',
                                                                }}
                                                            />
                                                        ))
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        )}

                        {
                            loading
                                ? <div className={`${styles.description}`}>
                                    <DescriptionLoader />
                                </div>
                                : publication?.user_description &&
                                <div className={`${styles.description}`}>
                                    <p className={styles.title}>Descripción</p>
                                    <p className={styles.content}>{publication?.user_description}</p>
                                </div>

                        }
                        {type === "salePost" && (
                            <div className={styles.salePostContainer}>
                                <div className={styles.vehicleDescription}>
                                    <div className={styles.descriptionHeader}>
                                        <p className={styles.title}>Descripción del vehículo</p>
                                        <p className={styles.subtitle}>
                                            <AutoAwesomeIcon className={styles.svg} />
                                            <span className={styles.text}>Generado por Linze IA</span>
                                        </p>
                                    </div>
                                    <p className={styles.descriptionText}>
                                        Este espacio se va a completar con una descripción generada por la IA después de que publiques tu auto.
                                    </p>
                                </div>

                                <div className={styles.additionalFeatures}>
                                    <p className={styles.title}>Características adicionales</p>

                                    {selectedFeatures.length === 0 ? (
                                        <p className={styles.descriptionText}>
                                            No añadiste características adicionales aún
                                        </p>
                                    ) : (
                                        <div className={styles.featuresList}>
                                            {selectedFeatures.map(({ name, code }: { name: string; code: string }) => (
                                                <Chip
                                                    key={code}
                                                    label={name}
                                                    className={styles.featureChip}
                                                    sx={{
                                                        margin: '0 4px 4px 0',
                                                        height: '28px',
                                                        color: 'rgba(115, 115, 115, 1)',
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className={styles.rightColumn}>
                    <div className={styles.rightBox}>
                        {
                            (loading && !publication?.id)
                                ? <div className={`${styles.information} ${loading && styles.loader}`}>
                                    <InformationLoader />
                                </div>
                                : <div className={`${styles.information} ${(publication?.certified || publication?.financingBonus) && styles.notPaddingBottom}`}>
                                    {logoDealerships && logoDealerships !== undefined && logoDealerships !== null && (
                                        <div className={styles.dealerLogo} onClick={handleDealerLogoClick}>
                                            <img src={logoDealerships} alt="Dealer logo" />
                                        </div>
                                    )}
                                    <p className={styles.description}>{publication?.year} | {addPointsInText(publication?.mileage)} km</p>
                                    <h2 className={styles.title}>{publication?.title}</h2>
                                    {
                                        publication?.version &&
                                        <h3 className={styles.version}>{publication?.version}</h3>
                                    }
                                    <p className={styles.price}>$ {addPointsInText(publication?.price)}</p>


                                    {
                                        type !== 'salePost' && type !== 'myPublication' && (
                                            publication?.sold
                                                ? <h3 className={styles.sold}>Vendido</h3>
                                                : (<div style={{ width: 'auto' }}>

                                                    {hasValidSuggestedPricesPublication && (
                                                        <div className={styles.priceIndicatorPublication} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img
                                                                src={
                                                                    getPriceCategoryPublication() === "good"
                                                                        ? images.checkVerde
                                                                        : getPriceCategoryPublication() === "fair"
                                                                            ? images.checkAmarillo
                                                                            : images.checkRojo
                                                                }
                                                                alt="Indicador de precio"
                                                                className={styles.priceIcon}
                                                                style={{ width: '16px', height: '16px', marginRight: '4px', }}
                                                            />
                                                            {getPriceCategoryPublication() === "good"
                                                                ? "Buen precio"
                                                                : getPriceCategoryPublication() === "fair"
                                                                    ? "Precio justo"
                                                                    : "Precio elevado"}
                                                        </div>
                                                    )}
                                                    <div className={styles.children}>{children}</div>

                                                </div>)
                                        )
                                    }
                                    {
                                        type === 'myPublication' && (
                                            publication?.sold
                                                ? <h3 className={styles.sold}>Vendido</h3>
                                                : (<div style={{ width: 'auto' }}>

                                                    {hasValidSuggestedPricesPublication && (
                                                        <div className={styles.priceIndicatorMyPublication} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img
                                                                src={
                                                                    getPriceCategoryPublication() === "good"
                                                                        ? images.checkVerde
                                                                        : getPriceCategoryPublication() === "fair"
                                                                            ? images.checkAmarillo
                                                                            : images.checkRojo
                                                                }
                                                                alt="Indicador de precio"
                                                                className={styles.priceIcon}
                                                                style={{ width: '16px', height: '16px', marginRight: '4px', }}
                                                            />
                                                            {getPriceCategoryPublication() === "good"
                                                                ? "Buen precio"
                                                                : getPriceCategoryPublication() === "fair"
                                                                    ? "Precio justo"
                                                                    : "Precio elevado"}
                                                        </div>
                                                    )}
                                                    <div className={styles.childrenPublication}>{children}</div>

                                                </div>)
                                        )
                                    }
                                    {
                                        loading
                                            ? <ul className={styles.detail}>
                                                <DetailLoader />
                                            </ul>
                                            : (publication?.detail && Array.isArray(publication?.detail)) &&
                                            <>
                                                {vehicleTypeSelected === "new" ? (
                                                    <ul className={styles.detail}>
                                                    </ul>
                                                ) : (
                                                    <ul className={styles.detail}>
                                                        {
                                                            publication?.detail?.map((item: any, index: number) => {
                                                                return (
                                                                    item?.key !== "bonus"
                                                                        ?
                                                                        <li key={index}>
                                                                            <img src={item?.icon} alt={item?.value} />
                                                                            <Markup content={boldBetweenAsterisks(item?.value)} />
                                                                        </li>
                                                                        :
                                                                        null
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                )}
                                            </>
                                    }


                                </div>
                        }

                        {publication?.records?.length > 0 && type === "salePost" && (
                            <div className={styles.additionalDetails}>
                                {publication.records.map((item: any, index: number) => (
                                    <p key={index} className={styles.detailText}>
                                        <img src={`${item?.icon}`} alt={item?.name} /> {item.value}
                                    </p>
                                ))}
                            </div>
                        )}
                        {type === "salePost" && (<div className={styles.buttonRow}>
                            <div>
                                {hasValidSuggestedPrices && (
                                    <div className={styles.priceIndicator}>
                                        <img
                                            src={
                                                getPriceCategory() === "good"
                                                    ? images.checkVerde
                                                    : getPriceCategory() === "fair"
                                                        ? images.checkAmarillo
                                                        : images.checkRojo
                                            }
                                            alt="Indicador de precio"
                                            className={styles.priceIcon}
                                            style={{ width: '18px', height: '18px' }}
                                        />
                                        {getPriceCategory() === "good"
                                            ? "Buen precio"
                                            : getPriceCategory() === "fair"
                                                ? "Precio justo"
                                                : "Precio elevado"}
                                    </div>
                                )}
                            </div>
                            <div className={styles.buttonss}>
                                <Button
                                    className={styles.btn}
                                    title="Negociar"
                                    onPress={() => console.log('Negociar')}
                                    tertiary
                                    disabled
                                    size='small'
                                />
                                <Button
                                    className={styles.btn}
                                    title="Comprar"
                                    onPress={() => console.log('Comprar')}
                                    primary
                                    disabled
                                    size='small'
                                />
                            </div>


                        </div>)
                        }
                        {type === "myPublication" && (
                            <div className={styles.imageSectionPublication} onClick={onLinzeCheckClick}>
                                <img
                                    src={images.autoIcar}
                                    alt="Descripción de la imagen"
                                    className={styles.promoImage}
                                />
                                <p className={styles.overlayPublication}>
                                    <p className={styles.overlayTitle}>icar</p>
                                    <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                                    <Button
                                        title="Solicitar Informe"
                                        onPress={onLinzeCheckClick}
                                        tertiary
                                        size='small'
                                        className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                                    />
                                </p>
                            </div>
                        )}

                        {type !== "myPublication" && (
                            <div className={styles.imageSection} onClick={onLinzeCheckClick}>
                                <img
                                    src={images.autoIcar}
                                    alt="Descripción de la imagen"
                                    className={styles.promoImage}
                                />
                                <p className={styles.overlay}>
                                    <p className={styles.overlayTitle}>icar</p>
                                    <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                                    <Button
                                        title="Solicitar Informe"
                                        onPress={onLinzeCheckClick}
                                        tertiary
                                        size='small'
                                        className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                                    />
                                </p>
                            </div>
                        )}

                        {
                            !loading && (publication?.certified || isBonus) &&
                            <div className={styles.certifiedFinancing}>
                                {
                                    publication?.certified &&
                                    <div className={`${styles.item} ${styles.certified}`}>
                                        <p>Vehículo verificado</p>
                                        <img src={images.check_blue} alt="vehículo verificado" />
                                    </div>
                                }
                                {
                                    isBonus &&
                                    <div className={`${styles.item} ${styles.financingBonus}`}>
                                        <img src={images.financingBonus} alt="bono con financiamiento" />
                                        <p>Bono con financiamiento</p>
                                    </div>
                                }
                            </div>
                        }

                        <div className={styles.rightColumnContent}>
                            {
                                hasValidSuggestedPrices && (
                                    <div className={styles.marketPriceSection}>
                                        <h3>Precios del mercado</h3>
                                        <div className={styles.marketPriceInfo}>


                                            <div className={styles.priceBar}>
                                                <div className={styles.priceBarInner}>
                                                    {/* Precio + etiqueta arriba del indicador */}
                                                    <div
                                                        className={styles.priceTag}
                                                        style={{ left: `${getIndicatorPosition()}%` }}
                                                    >
                                                        <p className={styles.actualPrice}>${addPointsInText(publication?.price)}</p>
                                                        <div className={styles.priceCategory}>
                                                            <img
                                                                src={
                                                                    getPriceCategory() === "good"
                                                                        ? images.checkVerde // buena imagen
                                                                        : getPriceCategory() === "fair"
                                                                            ? images.checkAmarillo // imagen regular
                                                                            : images.checkRojo // imagen cara
                                                                }
                                                                alt="Indicador de precio"
                                                                className={styles.priceIcon}
                                                                style={{ width: '18px', height: '18px' }}
                                                            />
                                                            {getPriceCategory() === "good"
                                                                ? "Buen precio"
                                                                : getPriceCategory() === "fair"
                                                                    ? "Precio justo"
                                                                    : "Precio elevado"}
                                                        </div>
                                                    </div>

                                                    {/* Línea + marcador */}
                                                    <div className={styles.pricePointer} style={{ left: `${getIndicatorPosition()}%` }} />
                                                </div>
                                            </div>


                                            <div className={styles.suggestedPriceDisplay}>
                                                <h3>${addPointsInText(publication?.suggestedPrice.sale)}</h3>
                                                <p>Precio Sugerido</p>
                                            </div>

                                            <p className={styles.priceInfo}>
                                                {getPriceDifferenceMessage()}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            {type === "salePost" &&
                                <div className={styles.salePostButtons}>
                                    {children}
                                </div>
                            }

                        </div>
                    </div>
                    {type !== "salePost" && hasValidSuggestedPricesPublication && (
                        <div className={styles.marketPriceSectionPublication}>
                            <h3>Precios del mercado</h3>
                            <div className={styles.marketPriceInfo}>
                                <div className={styles.priceBar}>
                                    <div className={styles.priceBarInner}>
                                        {/* Precio + etiqueta arriba del indicador */}
                                        <div
                                            className={styles.priceTag}
                                            style={{ left: `${getIndicatorPositionPublication()}%` }}
                                        >
                                            <p className={styles.actualPrice}>${addPointsInText(publication?.price)}</p>
                                            <div className={styles.priceCategory}>
                                                <img
                                                    src={
                                                        getPriceCategoryPublication() === "good"
                                                            ? images.checkVerde // buena imagen
                                                            : getPriceCategoryPublication() === "fair"
                                                                ? images.checkAmarillo // imagen regular
                                                                : images.checkRojo // imagen cara
                                                    }
                                                    alt="Indicador de precio"
                                                    className={styles.priceIcon}
                                                    style={{ width: '18px', height: '18px' }}
                                                />
                                                {getPriceCategoryPublication() === "good"
                                                    ? "Buen precio"
                                                    : getPriceCategoryPublication() === "fair"
                                                        ? "Precio justo"
                                                        : "Precio elevado"}
                                            </div>
                                        </div>

                                        {/* Línea + marcador */}
                                        <div className={styles.pricePointer} style={{ left: `${getIndicatorPositionPublication()}%` }} />
                                    </div>
                                </div>


                                <div className={styles.suggestedPriceDisplay}>
                                    <h3>${addPointsInText(publication?.suggested_prices?.suggested_price)}</h3>
                                    <p>Precio Sugerido</p>
                                </div>

                                <p className={styles.priceInfo}>
                                    {getPriceDifferenceMessage()}
                                </p>
                            </div>
                        </div>
                    )}
                </div>


            </div>
            {
                type === "publication"
                    ?
                    loading
                        ? <div className={`${styles.item} ${styles.similars}`}>
                            <VehicleSimilarsLoader />
                        </div>
                        : (publications && publications.length > 0)
                            ? <div className={`${styles.item} ${styles.similars} ${publications.length < 1 && styles.noArrows}`}>
                                <h2 className={styles.title}>Vehículos similares</h2>
                                <div className={styles.content}>
                                    <Slider
                                        type="normal"
                                        perView="auto"
                                        perGroup={1}
                                        limit={sliderLimit}
                                        spaceBetween={24}
                                        options={
                                            publications && publications.map((item: any, index: number) => (
                                                <NewCard
                                                    className={styles.newCard}
                                                    key={index}
                                                    navigation={`/autos/usados/${item._id}`}
                                                    item={item}
                                                    pressFavorite={() => clickFavorite(item)}
                                                    redirect={`/autos/usados/${item?._id}`}
                                                    user={null}
                                                    showSecondaryDescription={true}
                                                    showPrimaryDescription={true}
                                                    dealerLogo={item?.branch_data?.picture}
                                                />

                                            ))
                                        }
                                    />
                                </div>
                            </div>
                            :
                            null
                    :
                    null
            }
        </>
    )
}

export default memo(PublicationDetail);